export interface ValueProvider {
  get(name: string): any | Promise<any>
}

export class ObjectValueProvider implements ValueProvider {
  constructor(private values: Record<string, any>) {}
  get(name: string) {
    return this.values[name]
  }
}
